import React from 'react';
import { ResetPasswordForm } from '@features/auth/components/reset-password/ResetPasswordForm';

import { W2AuthChrome } from './W2AuthChrome';
import { useW2Paths } from './paths';

/**
 * Reset-password screen under `/e/*` (C-1 reset row). The arriving employee has
 * no JWT (the layout's activation clear guarantees it), so the reset POST carries
 * no Authorization header. `useResetPassword` reads `?token` / `?rpt` off the URL
 * unchanged. Success → navigate to the sibling login; a bad token errors inline
 * with the C-6 re-request link to the sibling forgot.
 */
export const W2ResetRoute: React.FC = () => {
  const paths = useW2Paths();
  return (
    <W2AuthChrome>
      <ResetPasswordForm loginPath={paths.login} forgotPath={paths.forgot} />
    </W2AuthChrome>
  );
};
